import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const StepsSection = () => {
  const sliderRef = React.useRef(null);

  const [activeTab, setActiveTab] = useState("yenile");
  const [animate, setAnimate] = useState(true);
  const handleTabChange = (tab) => {
    setAnimate(false);
    setTimeout(() => {
      setActiveTab(tab);
      setAnimate(true);
    }, 400);
  };
  const handlePrevClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleNextClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const stepsYenile = [
    {
      image: "/takas1.webp",
      title: "Ürün bilgilerini gir",
      info: "Satmak istediğin ürünün özellikleri ve kullanım durumuna dair temsili soruları yanıtla.",
    },
    {
      image: "/takas2.webp",
      title: "Ön teklif tutarını öğren",
      info: "Başvuru formundaki sorulara doğru yanıt verilmemesi ya da kapıdaki inceleme neticesinde fiyat değişimi olması durumunda, aradaki farkı kapıda ödemen gerekecektir.",
    },
    {
      image: "/takas3.webp",
      title: "Anında indirimli cihazını al",
      info: "Eski cihazına verilen ön teklif, yeni cihaz alırken indirim olarak sepetine yansıyacak.",
    },
    {
      image: "/takas4.webp",
      title: "Cihazını yedekle",
      info: "Kapıda eskiyi yenile yapılmadan önce, tüm kişisel bilgilerini ve kullanıcı hesap ayarlarını (icloud vb.) yedeklemeyi unutma.",
    },
    {
      image: "/takas5.webp",
      title: "Teslimat gününde adreste ol",
      info: "Yeni cihazın teslim edilirken eski cihazını senden alacağız. Bu yüzden teslimat gününde belirttiğin adreste olman gerekiyor.",
    },
    {
      image: "/takas6.webp",
      title: "Kurye cihazını kontrol edecek",
      info: "Kuryemizin cihazını inceleyebilmesi için cihazın çalışır durumda ve şarjının olmasına dikkat et.",
    },
    {
      image: "/takas7.webp",
      title: "Arada fark oluşursa, kapıda öde",
      info: "Kapıdaki inceleme neticesinde fiyat değişimi olursa veya eski cihazını vermekten vazgeçersen, aradaki farkı kapıda ödemen için sana online bir link gönderilecektir.",
    },
  ];

  const stepsNakit = [
    {
      image: "/nakit1.webp",
      title: "Ödeme yöntemini seç",
      info: "Satın almak istediğin yeni ürünün sayfasındaki 'Faydalan' butonuna tıkla, 'Nakit' yöntemini seç.",
    },
    {
      image: "/nakit2.webp",
      title: "Ürün bilgilerini gir",
      info: "Satmak istediğin ürünün özellikleri ve kullanım durumuna dair temsili soruları yanıtla.",
    },
    {
      image: "/nakit3.webp",
      title: "Ön teklif tutarını öğren",
      info: "Başvuru formundaki sorulara doğru yanıt verilmemesi ya da temsili sorulardan farklı bir sorun tespit edilmesi halinde bu tutar revize edilebilir.",
    },
    {
      image: "/nakit4.webp",
      title: "İletişim ve adres bilgilerini ekle",
      info: "Sana ulaşabileceğimiz bilgileri doğru ve eksiksiz bir şekilde bizimle paylaş.",
    },
    {
      image: "/nakit5.webp",
      title: "Teslimat yönetimi seç",
      info: "İster adresinden ücretsiz teslim alalım, ister kargoya teslim et. Tüm kişisel bilgilerini kaldırmayı unutma.",
    },
    {
      image: "/nakit6.webp",
      title: "Sipariş oluştur, başvurunu tamamla",
      info: "Başvuru formunu tamamladıktan sonra, siparişini tamamlaman gerekmektedir.",
    },
    {
      image: "/nakit7.webp",
      title: "Eski ürünün onay sürecinde",
      info: "Ürünün teknik ekipler tarafından detaylı olarak incelendikten sonra; ön teklif tutarı direkt onaylanır ya da revize teklif yapılır.",
    },
    {
      image: "/nakit8.webp",
      title: "Nakit Ödemen Hesabında",
      info: "Satış işleminin onaylanmasının ardından, nakit ödemen 3 iş günü içerisinde belirtilen IBAN hesabına yatırılır.",
    },
  ];

  const steps = activeTab === "yenile" ? stepsYenile : stepsNakit;

  const settings = {
    dots: false,
    infinite: false, // Son karta ulaştığında durmasını sağlıyor
    speed: 300, // Daha yavaş ve akıcı geçiş için hız artırıldı
    swipe: true, // Fareyle kaydırma etkin
    touchThreshold: 10, // Dokunma/kaydırma hassasiyeti artırıldı
    slidesToShow: 4, // Aynı anda gösterilecek slayt sayısı
    slidesToScroll: 1, // Her kaydırmada bir slayt ilerler
    draggable: true, // Fareyle kaydırma etkin
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className=" text-white py-10" style={{ backgroundColor: "#5726d0" }}>
      <h2 className="text-5xl font-bold text-center mb-8">
        Süreç nasıl işliyor?
      </h2>
      <div className="flex justify-center mb-8">
        <button
          onClick={() => handleTabChange("yenile")}
          className={`flex items-center px-6 py-2 rounded-xl mx-2 border focus:outline-none transition-transform duration-300 ${
            activeTab === "yenile"
              ? "bg-white text-black border-white scale-105" // Aktif olduğunda büyütme efekti
              : "bg-transparent text-white border-purple-300 hover:scale-105" // Pasifken hover efekti
          }`}
        >
          <img
            src={
              activeTab === "yenile" ? "/takas-black.svg" : "/takas-white.svg"
            }
            alt="Takas"
            className="mr-2 w-8 h-8"
          />
          <span className="text-lg"> Eskiyi Kapında Yenile</span>
        </button>
        <button
          onClick={() => handleTabChange("nakit")}
          className={`flex items-center px-6 py-2 rounded-xl mx-2 border focus:outline-none transition-transform duration-300 ${
            activeTab === "nakit"
              ? "bg-white text-black border-white scale-105" // Aktif olduğunda büyütme efekti
              : "bg-transparent text-white border-purple-300 hover:scale-105" // Pasifken hover efekti
          }`}
        >
          <img
            src={
              activeTab === "nakit" ? "/nakit-black.svg" : "/nakit-white.svg"
            }
            alt="Nakit"
            className="mr-2 w-8 h-8"
          />
          <span className="text-lg">Nakit</span>
        </button>
      </div>

      <div>
        <Slider ref={sliderRef} {...settings} className="overflow-x-hidden">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`p-4 transform transition-transform duration-500 ${
                animate ? "animate-fade-in" : "opacity-0 translate-y-10 "
              }`}
            >
              <div className="flex flex-col items-center bg-white rounded-[32px]  p-3 w-full max-w-[20rem] min-h-[32rem] border border-white mx-auto">
                <div
                  className="absolute top-[1.6rem]  left-[3.1rem] text-white rounded-tl-[32px] rounded-br-[12px] w-12 h-12 flex items-center justify-center font-bold "
                  style={{
                    backgroundColor:
                      activeTab === "yenile" ? "#6b82fa" : "#66d66e",
                  }}
                >
                  {index + 1}
                </div>

                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-auto mb-4 rounded mt-10"
                />
                <p className="font-bold mb-2 text-black text-xl">
                  {step.title}
                </p>
                <p className="text-md text-gray-600 text-center">{step.info}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="absolute right-[-8px] top-1/2 transform -translate-y-1/2">
                  <img src="/icon-right.svg" alt="#" />
                </div>
              )}
            </div>
          ))}
        </Slider>
        <div className="flex justify-center items-center mt-4 space-x-4">
          <button
            onClick={handlePrevClick}
            className={`w-12 h-12 rounded-full flex items-center justify-center  border ${
              sliderRef.current &&
              sliderRef.current.innerSlider.state.currentSlide === 0
                ? "bg-gray-300 text-gray-500 cursor-not-allowed focus:outline-none"
                : "bg-white text-black hover:bg-black focus:outline-none"
            }`}
            disabled={
              sliderRef.current &&
              sliderRef.current.innerSlider.state.currentSlide === 0
            }
          >
            <span className="text-lg font-bold ">{"<"}</span>
          </button>
          <button
            onClick={handleNextClick}
            className={`w-12 h-12 rounded-full flex items-center justify-center border ${
              sliderRef.current &&
              sliderRef.current.innerSlider.state.currentSlide ===
                sliderRef.current.innerSlider.state.slideCount -
                  sliderRef.current.innerSlider.props.slidesToShow
                ? "bg-gray-300 text-gray-500 cursor-not-allowed focus:outline-none"
                : "bg-white text-black hover:bg-black focus:outline-none"
            }`}
            disabled={
              sliderRef.current &&
              sliderRef.current.innerSlider.state.currentSlide ===
                sliderRef.current.innerSlider.state.slideCount -
                  sliderRef.current.innerSlider.props.slidesToShow
            }
          >
            <span className="text-lg font-bold">{">"}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepsSection;
